import {Col, Row} from "antd";
import styled from "styled-components";

export const Wrapper = styled(Row)`
    border-radius: 10px;
    background-color: white;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    padding: 12px 20px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
    z-index: 3;
    gap: 10px;
    border: 2px solid #aeef01;
    flex-shrink: 0;

    @media (max-width: 768px) {
        width: 100%;
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        padding: 10px;
    }
`;

export const LeftSection = styled(Col)`
    display: flex;
    flex-direction: row;
`;

export const InfoRow = styled(Col)`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex: 2;
    font-weight: 600;
    z-index: 5;
    cursor: pointer;
    white-space: nowrap;
    overflow: ${props => (props.$noWidth ? "visible" : "hidden")};
    text-overflow: ellipsis;
    min-width: 0;
    margin-bottom: 16px;
`;

export const InfoRowForUpload = styled(Col)`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex: ${props => (props.$noWidth ? "0 0 auto" : "1")};
    font-weight: 600;
    z-index: 5;
    cursor: pointer;
    white-space: nowrap;
    overflow: ${props => (props.$noWidth ? "visible" : "hidden")};
    text-overflow: ellipsis;
    min-width: 0;
`;

export const InfoIcon = styled.img`
    margin-right: 5px;
    height: 14px;
    flex-shrink: 0;
`;

export const InfoSeperator = styled.div`
    width: 100%;
    height: 1px;
    margin: 15px 0;
    background-color: #d9d9d9;
`;

export const SectionTab = styled.div`
    width: auto;
    height: auto;
    background-color: #fff;
    position: absolute;
    border-radius: 10px;
    //figma dropshadow x:3 y:4 bluer:10.8 spread:0 color:rgba(0,0,0,0.25)
    box-shadow: 3px 4px 10.8px 0px rgba(0, 0, 0, 0.25);
    top: -25px;
    left: 8px;
    padding: 3px 6px 20px 6px;
    z-index: -1;
    font-weight: 700;
    display: flex;
    justify-content: center;
    flex-shrink: 0;
`;

export const SectionIcon = styled.img`
    margin-right: 5px;
    flex-shrink: 0;
`;
